import React from 'react';
import { Box, Typography, CircularProgress, Fade } from '@mui/material';

const SplashScreen: React.FC = () => {
  return (
    <Fade in={true} timeout={500}>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
          color: 'white',
          zIndex: 9999,
        }}
      >
        {/* App Logo/Icon */}
        <Box
          sx={{
            mb: 3,
            animation: 'pulse 2s ease-in-out infinite',
            '@keyframes pulse': {
              '0%': { transform: 'scale(1)' },
              '50%': { transform: 'scale(1.1)' },
              '100%': { transform: 'scale(1)' },
            },
          }}
        >
          <img 
            src="/treffpunkslogo.svg" 
            alt="TreffPunkts Logo" 
            style={{
              width: '310px',
              height: '310px',
              filter: 'brightness(0) invert(1)', // Makes the logo white to match the design
            }}
          />
        </Box>

        {/* App Name */}
        <Typography
          variant="h3"
          component="h1"
          sx={{
            fontWeight: 'bold',
            mb: 1,
            textAlign: 'center',
            letterSpacing: '0.5px',
          }}
        >
          TreffPunkts
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mb: 4,
            opacity: 0.9,
            textAlign: 'center',
            fontWeight: 300,
          }}
        >
          Discover Amazing Activities
        </Typography>

        {/* Loading Indicator */}
        <CircularProgress
          size={50}
          thickness={4}
          sx={{
            color: 'rgba(255, 255, 255, 0.8)',
            mb: 2,
          }}
        />

        <Typography
          variant="body2"
          sx={{
            opacity: 0.7,
            textAlign: 'center',
          }}
        >
          Loading your personalized experience...
        </Typography>
      </Box>
    </Fade>
  );
};

export default SplashScreen; 